import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from "../../../../../environments/environment";
import {CommonResponse} from "../../../response/common.response";
import {SecurityService} from "../../security.service";
import {UtilityService} from "../../utility.service";


@Injectable({
    providedIn: 'root'
})
export class ApiOperadorRepository {
    /**
     * Contiene la ruta de conexión a servicios publicos
     */
    API_URI = environment.API_URI;
    PUBLIC_URI = environment.PUBLIC_URI;
    API_ITURRIAPP = environment.API_ITURRIAPP;

    // tslint:disable-next-line:max-line-length
    constructor(private http: HttpClient, private securityService: SecurityService, private utilityService: UtilityService) {
    }

    // @ts-ignore
    public async login(credentials: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.PUBLIC_URI + 'usuario/login', credentials).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async deleteTokenByToken(token: string | null): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.PUBLIC_URI + 'usuario/deleteTokenByToken/' + token).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async aceptarTerminosYCondiciones(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/aceptarTerminosCondiciones').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }


    // @ts-ignore
    public async buscarClientesPorTexto(objValorBusqueda: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/listarClientesBusqueda', objValorBusqueda).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async aceptarTerminosYCondiciones(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/aceptarTerminosCondiciones').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getClientesPaginate(objEnvio: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'visoroperador/getClientesPaginate', objEnvio).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getTiposDocumentoCliente(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/getListTiposDocumentos').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getEstadosCliente(): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'visoroperador/getEstadosCliente').toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async consultarRuc(ruc: string): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_ITURRIAPP + `microservice/search/ruc/${ruc}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async buscarClienteByRUC(ruc: string): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + `visoroperador/cliente/search/ruc/${ruc}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async crearCliente(obj: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + `visoroperador/crearCliente`, obj).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async actualizarCliente(clienteID: any, obj: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.put(this.API_URI + `visoroperador/actualizarCliente/${clienteID}`, obj).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }
    
    // @ts-ignore
    public async getClienteById(clienteID: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + `visoroperador/getClienteByID/${clienteID}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getAdjuntosCliente(clienteID: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + `visoroperador/getDocumentosClienteByID/${clienteID}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async eliminarAdjuntoCliente(archivoID: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.delete(this.API_URI + `visoroperador/eliminarAdjuntoCliente/${archivoID}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getClienteListSearch(obj: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + `visoroperador/getClienteListSearch`, obj).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

    // @ts-ignore
    public async getDocumentosObservadosCliente(clienteId: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + `visoroperador/getDocumentosObservados/${clienteId}`).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }

}
